module.exports = __webpack_public_path__ + "static/media/xml.ff5af8be.svg";